import React, { useState, useEffect, useCallback } from "react";
import { useRouter } from "next/router";
import Container from "./Container";
import StopCampaignModal from "./StopCampaignModal";
import {
  useEthers,
  useNotifications,
  DEFAULT_SUPPORTED_CHAINS,
} from "@usedapp/core";
import { KARATDAO_DEFAULT_SUPPORTED_CHAINS } from "@/chain-info/KaratDaoSupportedChain";
// import { getWalletClaimInfo } from '../models/project';
import { formatUnits } from "@ethersproject/units";
import { Web3ModalButton } from "./Web3ModalButton";
import { Loader } from "@mantine/core";
// import OwnerActions from '../components/OwnerActions';
import { useClaimAirdrop } from "../hooks/useClaimAirdrop";
// import PageNotFound from './PageNotFound';
import { trimAddr } from "../utils/helper";
import useCampaignInfo from "../hooks/useCampaignInfo";
import useFetchData from "../hooks/useFetchData";
// import urlToHttp from '../utils/urlToHttp';
import useClaimed from "../hooks/useClaimed";
import { utils } from "ethers";
import ClaimModal from "./ClaimModal";
import * as ReactGA from "@/services/ga";
import EditCampaignModal from "./EditCampaignModal";
// import { useFormik } from 'formik';
import useFetchEligible from "../hooks/useFetchEligible";
import ImageProcessor from "./ImageProcessor";
import EmailAuthModal from "./account/EmailAuthModal";
import useAccountAnonymousInfo from "../hooks/useAccountAnonymousInfo";
import { Requirement } from "@airdrop/services/form";
import { useTypedSelector } from "@/stores";
import PageHead from "@/components/common/PageHead";
import uriToHttp from "@airdrop/utils/urlToHttp";
import Head from "next/head";
import { TDK } from "@/config/config";
import { getChainIcon } from "@/utils/format";
import EmptyContent from "@/components/common/EmptyContent";
import { useNetwork, useSwitchNetwork } from "wagmi";
import useAccount from "@/hooks/useAccount";
import mixpanel from "mixpanel-browser";
import * as Sentry from "@sentry/nextjs";

const stopIcon = "/airdrop_assets/stop.png";
const editIcon = "/airdrop_assets/edit.png";
const twitterIcon = "/airdrop_assets/twitter.png";
const discordIcon = "/airdrop_assets/discord.png";
const etherscanIcon = "/airdrop_assets/etherscan.png";
const linkIcon = "/airdrop_assets/link.png";
const coinIcon = "/airdrop_assets/coin.png";
const nftIcon = "/airdrop_assets/nft.png";
const leftArrow = "/airdrop_assets/arrow-left-solid.svg";

const CamapignDetail = ({
  campaignType,
  setErrorMessage,
}: {
  campaignType: string;
  setErrorMessage: Function;
}) => {
  const router = useRouter();
  const { chainName, address } = router.query as any;
  const [claimModalOpened, setClaimModalOpened] = useState(false);
  const [editModalOpened, setEditModalOpened] = useState(false);
  const [stopModalOpened, setStopModalOpened] = useState(false);
  const [emailAuthOpened, setEmailAuthOpened] = useState(false);
  const [claimStatus, setClaimStatus] = useState("claiming");
  const expectedChain = KARATDAO_DEFAULT_SUPPORTED_CHAINS.find(
    (network) => network.chainName.toLowerCase() === chainName?.toLowerCase()
  ); //getExplorerAddressLink
  const expectedChainId = expectedChain?.chainId;
  const chainNameEth = chainName === "Mainnet" ? "Ethereum" : chainName;
  const { chain } = useNetwork();
  const { address: account } = useAccount();
  const { switchNetworkAsync } = useSwitchNetwork();

  const { notifications } = useNotifications();

  const campaignAddr = address
    ? utils.isAddress(address)
      ? address
      : undefined
    : undefined;
  const campaignAddrArray = address ? [address] : undefined;
  const [showStopPrompt, setShowStopPrompt] = useState(false);
  // const { campaignInfo, loading: campaignLoading } = useCampaignInfo(
  //   campaignType?.toUpperCase(),
  //   campaignAddrArray,
  //   expectedChainId
  // );
  const { campaignInfo } = useCampaignInfo(
    //loading: campaignLoading FIXME 0608
    campaignType?.toUpperCase(),
    campaignAddrArray,
    expectedChainId
  );
  console.log("campaignInfo", campaignInfo);
  const campaign = campaignInfo[0];
  const {
    loading: baseInfoURILoading,
    // error: baseInfoURIError,
    data: baseInfoURIData,
  } = useFetchData(campaign?.baseInfoURI);
  const info = {
    description: "",
    twitter_url: "",
    discord_url: "",
    website_url: "",
    opensea_url: "",
    thumbnail: "",
  };
  const campaign_address = address;
  // const wallet_address = account;
  // console.log(campaign);

  const {
    loading: frozenInfoURILoading,
    // eslint-disable-next-line
    error: frozenInfoURIError,
    data: frozenInfoURIData,
  } = useFetchData(campaign?.frozenInfoURI);
  const claimInfoURL =
    // There's a bug with the claim info for this campaign
    // claimInfo could be undefined..
    address === "0xb403805916ccd23624a706e9fd37c713bb38078a" &&
    chainName === "Polygon"
      ? "ipfs://QmWQyzLhntqAc6Kfn2JWgqDXq4oXqwuGi44yR9oUCPkNi3"
      : frozenInfoURIData?.claimInfo;

  // turn all upper case to lower case
  const wallet_address = account;
  const wallet_address_lower = wallet_address?.toLowerCase();

  const {
    loading: claimedLoading,
    error: claimedError,
    data: claimedEligible,
  } = useFetchEligible(
    expectedChainId,
    campaign_address,
    wallet_address_lower,
    claimInfoURL
  );
  const isActive = campaign?.isActive;
  const isGone = true
    ? campaign?.reach?.toNumber() === campaign?.claimedNum?.toNumber()
    : false;
  const proof = account ? claimedEligible?.proof : null;
  const amount = account ? claimedEligible?.amount : null;
  const { claimed } = useClaimed(campaignAddr, account, expectedChainId);
  //check if the user is claimed or not
  const isClaimed = proof && claimed;
  // check if a user is eligible to claim
  const isEligible = proof != null && claimedError == null; //proof === [];
  // const campaign_address = "0x60aA3BBe0f411d7E677c29210f156F1BfC0Ac99e";
  // const wallet_address = "0x37422a43cf57Ea71B6aF354Ee7BA5a77c56C9E20";

  const { claimAirdrop, claimAirdropState } = useClaimAirdrop(
    campaignType,
    campaignAddr
  );

  useEffect(() => {
    if (
      notifications.filter(
        (notification) =>
          notification.type === "transactionSucceed" &&
          notification.transactionName === "Claim Airdrop"
      ).length > 0
    ) {
      setClaimStatus("finished");
    }
  }, [notifications]);

  useEffect(() => {
    if (claimAirdropState.status === "Exception") {
      setClaimModalOpened(false);
      setErrorMessage(new Error(claimAirdropState.errorMessage));
      mixpanel.track("claim_airdrop_error", claimAirdropState);
      Sentry.captureException(new Error(claimAirdropState.errorMessage));
    }
  }, [claimAirdropState, setErrorMessage]);

  const isOwner = account && account === campaign?.owner;
  const isCSV =
    frozenInfoURIData?.requirements === "CSV" ||
    frozenInfoURIData?.csv === true;
  const csvName = isCSV
    ? campaign.name.includes("Elysium")
      ? "Elysium Special Guest List RSVP"
      : campaign.name.includes("NO HESI KEY")
      ? "Holder of NHCC"
      : campaign.name.includes("LiveArt: Meta-Morphic x Machina")
      ? "KaratDAO Community with 1+ ETH"
      : frozenInfoURIData?.csvName || "Private"
    : null;
  const HESI_TEXT =
    "No Hesi is an Exclusive Elite Group. Being a Holder of this this key signifies that you are an OG and diamond hands holder. You officially have the keys to our Metaverse Island and game.";
  const description = campaign?.name.includes("NO HESI KEY")
    ? HESI_TEXT
    : baseInfoURIData?.description;
  // const promotionalText = 'Passholders will receive exclusive airdrops in the future including: $BNB, $ANKR, $KCS, $GMT, and $KARAT.';
  const discord_url = campaign?.name.includes("Tiger VC DAO & Consensus")
    ? "https://discord.gg/Ng69Qehq6e"
    : baseInfoURIData?.discord_url;
  const website_url = campaign?.name.includes("Tiger VC DAO & Consensus")
    ? "https://tigervcdao.com/"
    : baseInfoURIData?.website_url;
  const dynamic_fit = campaign?.name.includes("StepG&Karat")
    ? "object-contain"
    : "object-cover";
  const disabled =
    isClaimed ||
    baseInfoURILoading ||
    frozenInfoURILoading ||
    !isEligible ||
    !isActive ||
    isGone;
  const loading =
    // campaignLoading || //FIXME 0608 When you switch from another chain to the campaign chain, it will forever load. Temp workaround so far
    baseInfoURILoading || frozenInfoURILoading;
  const chainIcon = getChainIcon(chainNameEth);
  const { accountInfo } = useAccountAnonymousInfo();

  const verified = !!accountInfo?.is_email_verified;

  const action = useCallback(async () => {
    if (!chain || !expectedChainId || !switchNetworkAsync) {
      return;
    }
    if (chain.id !== expectedChainId) {
      switchNetworkAsync(expectedChainId);
    } else if (isEligible && !isClaimed) {
      ReactGA.event("claim", {
        event_category: "button",
      });
      if (verified) {
        setClaimStatus("claiming");
        setClaimModalOpened(true);
        await claimAirdrop(amount, proof);
      } else {
        setEmailAuthOpened(true);
      }
    }
  }, [
    verified,
    claimAirdrop,
    chain,
    switchNetworkAsync,
    expectedChainId,
    amount,
  ]);

  const changeEmailAuth = async (isOpen: boolean) => {
    setEmailAuthOpened(isOpen);
    if (!isOpen) {
      setClaimStatus("claiming");
      setClaimModalOpened(true);
      await claimAirdrop(amount, proof);
    }
  };

  const loadingText = () => {
    // if (isOwner) return 'View Transactions';

    if (claimedLoading)
      return (
        <div className="flex flex-row items-center">
          <div className="mr-1">Loading</div>
          <Loader color="#292939" size={14} />
        </div>
      );
    if (isClaimed) return "Claimed";
    // if (claimException) return 'Claim Failed';
    if (isActive === false) return "Campaign has been stopped";
    if (isGone) {
      return "Nothing Left";
    }
    if (isEligible) {
      if (chain?.id !== expectedChainId) {
        return `Switch to ${expectedChain?.chainName} to claim`;
      }
      return "Claim";
    }
    if (!isEligible) return "You are not eligible";
  };
  const secondaryText = (): string => {
    // if (isOwner) return '';
    // if (claimException) return claimAirdropState.errorMessage!;
    if (isEligible && frozenInfoURIData) {
      if (campaignType === "NFT") {
        return `Eligible for ${Number(amount)} ${campaignType}`;
      } else {
        const formattedAmount = parseFloat(
          formatUnits(amount, frozenInfoURIData.airdropToken.decimals)
        );
        return `Eligible for ${formattedAmount} ${frozenInfoURIData.airdropToken.symbol}`;
      }
    }
    return "";
  };

  if (
    campaign?.address === "0xcaaac618b5dec930c4c7c00d011a91196b112427" &&
    campaign?.name === "Hay twitter airdrop campaign for eligible winners"
  ) {
    campaign.name = "HAY twitter airdrop campaign for eligible winners";
  }

  const displayTotal = !(
    (campaign?.name === "HAY airdrop for early borrowers" &&
      campaign?.address === "0x8c33532386aead57d0643d6a66c57ae77d5df2de") ||
    (campaign?.name === "HAY twitter airdrop campaign for eligible winners" &&
      campaign?.address === "0xcaaac618b5dec930c4c7c00d011a91196b112427")
  );
  // campaign.name != 'HAY airdrop for early borrowers';

  useEffect(() => {}, [baseInfoURIData]);
  const editModalInit = () => {
    setEditModalOpened(true);
  };
  const stopModalInit = () => {
    setShowStopPrompt(true);
    setStopModalOpened(true);
  };

  const communityList = useTypedSelector((state) => {
    return state.community.list;
  });

  let tdk;

  if (campaign?.name) {
    tdk = {
      title: campaign.name,
      description: description,
      keywords: `KaratDAO,${chainNameEth},${campaignType}`,
      cover: uriToHttp(baseInfoURIData?.image)[0],
    };
  }

  if (!address) {
    return (
      <PageHead
        tdk={{
          ...TDK,
          title: `KaratDAO ${
            campaignType === "NFT" ? "NFT" : "Token"
          } Campaign`,
          description: "Claim your airdrop today on KaratDAO",
        }}
      ></PageHead>
    );
  }

  return (
    <Container>
      <PageHead tdk={tdk}></PageHead>

      {loading ? (
        <div className="w-full h-full flex items-center justify-center">
          <Loader color="#ADB5FF" />
        </div>
      ) : !campaign ? (
        // <PageNotFound name="Campaign" />
        <div></div> //FIXME 0608 When it's loading,  we don't show the page not found
      ) : (
        <div className="flex flex-wrap sm:grid sm:grid-cols-2 sm:space-x-4 max-w-5xl mx-auto p-5 md:p-14">
          <div className="flex flex-col items-start justify-start">
            <div className="relative flex flex-col ">
              {/* {!expectedChain?.isTestChain ? ( */}
              {true ? (
                <div className="absolute w-full p-4 font-semibold">
                  <div className="flex flex-row items-center justify-between">
                    <div className="flex items-center rounded-sm bg-[#191926] text-bodyS text-white px-2 py-1 ">
                      <img
                        className="mr-1 h-4 "
                        src={chainIcon}
                        alt="chain_icon"
                      />
                      <div>{chainNameEth}</div>
                    </div>
                    <div className="flex flex-row items-center">
                      <img
                        className="mr-1 h-8 rounded-full"
                        src={campaignType === "NFT" ? nftIcon : coinIcon}
                        alt="type_icon"
                      />
                      <div className="rounded-sm text-bodyS text-white bg-[#191926] px-2 py-1">
                        {campaignType === "NFT"
                          ? "NFT"
                          : frozenInfoURIData?.airdropToken?.name}
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}

              <ImageProcessor
                src={baseInfoURIData?.image}
                size="s600"
                data-testid="campaign-image"
                className={`${dynamic_fit} h-96 w-96 rounded-md`}
              />
              {/* <Button
                className="flex justify-center px-12 mt-10 mb-10 btn-pri"
                onClick={editModalInit}
              >
                {' '}
                Edit Campaign
              </Button> */}
            </div>
            <div className="mt-2 flex">
              {isOwner ? (
                <div className="flex space-x-3">
                  <button
                    className="btn-bgv2 text-white flex items-center justify-center px-6"
                    onClick={editModalInit}
                  >
                    <img className="mr-2 h-4" src={editIcon} alt="edit" />
                    <div>Edit</div>
                  </button>
                  <button
                    className="btn-bgv2 text-white flex items-center justify-center px-6"
                    onClick={stopModalInit}
                  >
                    <img className="mr-2 h-4" src={stopIcon} alt="stop" />
                    <div>Stop</div>
                  </button>
                </div>
              ) : null}
            </div>
          </div>
          <div>
            <div className="mb-3 text-lg font-bold" data-testid="campaign-name">
              {campaign.name}
            </div>
            <div className="mb-3 flex">
              <p className="text-gray1">Created By &nbsp;</p>
              <a
                href={expectedChain?.getExplorerAddressLink(campaign.owner)}
                target="_blank"
                rel="noreferrer"
                className="text-primary"
              >
                {trimAddr(campaign.owner)}
              </a>
            </div>

            <div className="">
              <div className="mb-6 flex items-center space-x-7">
                {baseInfoURIData?.twitter_url && (
                  <a
                    href={baseInfoURIData?.twitter_url}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img className="h-4" src={twitterIcon} alt="twitter" />
                  </a>
                )}
                {discord_url && (
                  <a href={discord_url} target="_blank" rel="noreferrer">
                    <img className="h-4" src={discordIcon} alt="discordIcon" />
                  </a>
                )}
                {website_url && (
                  <a href={website_url} target="_blank" rel="noreferrer">
                    <img className="h-5" src={linkIcon} alt="linkIcon" />
                  </a>
                )}
                <a
                  href={expectedChain?.getExplorerAddressLink(address!)}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    className="h-4"
                    src={etherscanIcon}
                    alt="etherscanIcon"
                  />
                </a>
              </div>
            </div>

            <div className=" text-gray">
              <div
                className="whitespace-pre-line break-words"
                data-testid="campaign-desc"
              >
                {description}
              </div>
              {/* <div className="mt-2">{promotionalText}</div> */}
            </div>
            <div className="mt-8 mb-6 border border-bgv"></div>
            <div className="mb-3 ">Requirements to Qualify</div>
            {frozenInfoURIData?.version && frozenInfoURIData.version >= 2 ? (
              <div className="mb-10 flex flex-wrap">
                {(
                  frozenInfoURIData?.requirements?.[0]
                    ?.requirement as Requirement[]
                )?.map((item: any, index) => {
                  if (item.type === "community") {
                    return (
                      <div
                        key={`community-${index}`}
                        className="mb-2 mr-2 rounded-md border border-gray_e7 px-3 py-3 "
                      >
                        {item.community.name}
                        <div className="text-xs text-gray1">Community</div>
                      </div>
                    );
                  } else if (item.type === "whitelist") {
                    return (
                      <div
                        key={`whitelist-${index}`}
                        className="mb-2 mr-2 rounded-md border border-gray_e7 px-3 py-3"
                      >
                        {item.name}
                        <div className="text-xs text-gray1">AllowList</div>
                      </div>
                    );
                  } else {
                    return (
                      <div
                        key={`token-${index}`}
                        className="mb-2 mr-2 rounded-md border border-gray_e7 px-3 py-3"
                      >
                        <div>{item.token?.name}</div>
                        <div className="text-xs text-gray1">
                          Min. {item.requiredAmount}
                        </div>
                      </div>
                    );
                  }
                })}
              </div>
            ) : (
              <div className="mb-10 flex">
                {isCSV ? (
                  <div className="mr-2 rounded-md border border-gray_e7 px-3 py-3">
                    <div>{csvName}</div>
                  </div>
                ) : (
                  frozenInfoURIData?.requirements?.map((items: any) =>
                    items.requirement?.map((req: any, index: any) => (
                      <div
                        key={index}
                        className="mr-2 rounded-md border border-gray_e7 px-3 py-3"
                      >
                        <div>{req.requiredToken?.name}</div>
                        {/* FIXME */}
                        {/* <div>{JSON.stringify(req)}</div> */}
                        <div className="text-xs text-gray1">
                          Min. {req.requiredAmount}
                        </div>
                      </div>
                    ))
                  )
                )}
              </div>
            )}

            <div className="mt-8 mb-6 border border-bgv"></div>

            <div className="mb-4">Airdrop Details</div>
            <div className="grid grid-cols-2 ">
              {displayTotal && (
                <div>
                  <div className="mb-1 text-gray1">Total Supply</div>
                  <div className="mb-5 ">{campaign.reach.toString()}</div>
                </div>
              )}
              {campaign.claimedNum > 10 ? (
                <div>
                  <div className="mb-1 text-gray1">Airdrop Claimed</div>
                  <div className="mb-5 ">{campaign.claimedNum.toString()}</div>
                </div>
              ) : null}
              {campaignType === "TOKEN" ? (
                <div>
                  <div className="mb-1 text-gray1">Token Address</div>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={expectedChain?.getExplorerAddressLink(
                      frozenInfoURIData?.airdropToken?.address
                    )}
                    className="font-bold text-primary"
                  >
                    {trimAddr(frozenInfoURIData?.airdropToken?.address, 5)}
                  </a>
                </div>
              ) : null}
            </div>
            <div className="mt-5 flex w-full flex-col items-start justify-center sm:mt-10">
              {!account ? (
                <div className="flex w-full flex-col items-center justify-center sm:w-auto">
                  <Web3ModalButton className={`w-full sm:w-auto`} />
                </div>
              ) : (
                // claim button
                <div className="flex w-full flex-col items-center justify-center sm:w-auto">
                  <button
                    className={`btn-pri flex w-full flex-row justify-center px-12 sm:w-auto  ${
                      disabled && "bg-gray2 hover:bg-gray2"
                    }`}
                    disabled={disabled}
                    onClick={action}
                    data-testid="claim-btn"
                  >
                    {loadingText()}
                  </button>
                  {secondaryText() && (
                    <div className="mt-2 text-xs text-gray1">
                      {secondaryText()}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      <ClaimModal
        opened={claimModalOpened}
        // opened={true}
        setOpened={setClaimModalOpened}
        claimStatus={claimStatus}
        // claimStatus={'finished'}
        // setClaimStatus={setClaimStatus}
      />

      <EditCampaignModal
        opened={editModalOpened}
        setOpened={setEditModalOpened}
        baseInfo={baseInfoURIData ? baseInfoURIData : info}
        campaignAddrArray={campaignAddrArray}
        campaignType={campaignType}
        expectedChain={expectedChain}
      ></EditCampaignModal>
      <StopCampaignModal
        campaign={campaign}
        opened={stopModalOpened}
        setOpened={setStopModalOpened}
        campaignAddrArray={campaignAddrArray}
        campaignType={campaignType}
        expectedChain={expectedChain}
        showStopPrompt={showStopPrompt}
        setShowStopPrompt={setShowStopPrompt}
      ></StopCampaignModal>
      <EmailAuthModal
        opened={emailAuthOpened}
        setOpened={changeEmailAuth}
      ></EmailAuthModal>
    </Container>
  );
};

export default CamapignDetail;
